import { ui } from '../../data/ui';
import { ScrollReveal } from '../ui/ScrollReveal';
import { Button } from '../ui/Button';
import './CTA.css';

export function CTA() {
  return (
    <section className="section cta-section">
      <div className="container">
        <ScrollReveal>
          <div className="cta-card glass-card">
            <div className="bg-glow cta-glow" />
            <h2 className="cta-title">{ui.sections.ctaTitle}</h2>
            <p className="cta-text">{ui.sections.ctaText}</p>
            <div className="cta-actions">
              <Button to="/contact" variant="primary">{ui.sections.getInTouch}</Button>
              <Button to="/services" variant="secondary">{ui.sections.viewServices}</Button>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
